import { render, staticRenderFns } from "./SugarAdded.vue?vue&type=template&id=2abe246a&scoped=true"
import script from "./SugarAdded.vue?vue&type=script&lang=ts"
export * from "./SugarAdded.vue?vue&type=script&lang=ts"
import style0 from "./SugarAdded.vue?vue&type=style&index=0&id=2abe246a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abe246a",
  null
  
)

export default component.exports